import { browserHistory } from 'react-router'

export default browserHistory
